// courseData.js
import {
	courseCiricullum as htmlCssCurriculum,
	courseHeading as htmlCssHeading,
	courseSubtitle as htmlCssSubtitle,
	CourseWhatLearn as HtmlCssWhatLearn,
	CourseIncludes as HtmlCssIncludes,
	CourseReq as HtmlCssReq,
	CourseDesc as HtmlCssDesc,
	CourseFor as HtmlCssFor,
	instructorDetails as htmlCssInstructor,
} from "./htmlCssCiricullum";

import {
	courseCiricullum as jsCurriculum,
	courseHeading as jsHeading,
	courseSubtitle as jsSubtitle,
	CourseWhatLearn as JsWhatLearn,
	CourseIncludes as JsIncludes,
	CourseReq as JsReq,
	CourseDesc as JsDesc,
	CourseFor as JsFor,
	instructorDetails as jsInstructor,
} from "./jsCiricullum";

import InstructorBio from "./InstructorBio";
import InstructorBioBaad from "./InstructorBioBaad";

import {
	courseCiricullum as uiuxCurriculum,
	courseHeading as uiuxHeading,
	courseSubtitle as uiuxSubtitle,
	CourseWhatLearn as UiuxWhatLearn,
	CourseIncludes as UiuxIncludes,
	CourseReq as UiuxReq,
	CourseDesc as UiuxDesc,
	CourseFor as UiuxFor,
	instructorDetails as uiuxInstructor,
} from "./uiuxCiricullum";

export const courseData = {
	"html-css": {
		courseCiricullum: htmlCssCurriculum,
		courseHeading: htmlCssHeading,
		courseSubtitle: htmlCssSubtitle,
		CourseWhatLearn: HtmlCssWhatLearn,
		CourseIncludes: HtmlCssIncludes,
		CourseReq: HtmlCssReq,
		CourseDesc: HtmlCssDesc,
		CourseFor: HtmlCssFor,
		instructorDetails: htmlCssInstructor,
		InstructorBio,
	},
	javascript: {
		courseCiricullum: jsCurriculum,
		courseHeading: jsHeading,
		courseSubtitle: jsSubtitle,
		CourseWhatLearn: JsWhatLearn,
		CourseIncludes: JsIncludes,
		CourseReq: JsReq,
		CourseDesc: JsDesc,
		CourseFor: JsFor,
		instructorDetails: jsInstructor,
		InstructorBio,
	},
	"ui-ux": {
		courseCiricullum: uiuxCurriculum,
		courseHeading: uiuxHeading,
		courseSubtitle: uiuxSubtitle,
		CourseWhatLearn: UiuxWhatLearn,
		CourseIncludes: UiuxIncludes,
		CourseReq: UiuxReq,
		CourseDesc: UiuxDesc,
		CourseFor: UiuxFor,
		instructorDetails: uiuxInstructor,
		InstructorBio: InstructorBioBaad,
	},
};
